import { GET_FORM_ACTIONS_SUCCESS } from './';

export default payload => dispatch =>
  dispatch({
    type: GET_FORM_ACTIONS_SUCCESS,
    payload,
  });
